export const IS_EXPLAINER_MODAL_DISMISSED_KEY =
  'isSeasonalPromoExplainerModalDismissed'

export const isExplainerModalDismissed = () => {
  try {
    const item = window.localStorage.getItem(IS_EXPLAINER_MODAL_DISMISSED_KEY)

    return item === 'true'
  } catch (error) {
    return false
  }
}
